import axios, { AxiosError } from "axios";
import { useEffect, useState } from "react";
import AccentHeaderLayout from "./layout/AccentHeaderLayout";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import Clients from "./pages/Clients/Clients";

import Users from "./pages/Users/Users";
import Login from "./pages/Login/Login";
import { api } from "./api/api";

import Spaces from "./pages/Spaces/Spaces";
import Equipment from "./pages/Equipment/Equipment";
import Services from "./pages/Services/Services";
import Packages from "./pages/Packages/Packages";
import Settings from "./pages/Settings/Settings";
import Scheduling from "./pages/Scheduling/SchedulingForAdmins";

function App() {
  const [token, setToken] = useState(localStorage.getItem("token") || null);
  const navigate = useNavigate();

  useEffect(() => {
    api.interceptors.response.use(
      (response) => {
        return response;
      },
      (err: AxiosError) => {
        if (err.status === 401) {
          setToken(null);
          localStorage.removeItem("token");
          navigate("login");
        }
      }
    );
  }, []);

  if (!token) {
    return (
      <Routes>
        <Route path="/login" element={<Login setToken={setToken} />} />
        <Route path="*" element={<Navigate replace to={"/login"} />} />
      </Routes>
    );
  }

  return (
    <AccentHeaderLayout sx={{ position: "absolute" }}>
      <Routes>
        <Route path="/" element={<Navigate replace to={"/users"} />} />
        <Route path="/users" element={<Users />} />
        <Route path="/spaces" element={<Spaces />} />
        <Route path="/equipment" element={<Equipment />} />
        <Route path="/services" element={<Services />} />
        <Route path="/packages" element={<Packages />} />
        <Route path="/scheduling" element={<Scheduling />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/clients" element={<Clients />} />

        <Route path="*" element={<></>} />
      </Routes>
    </AccentHeaderLayout>
  );
}

export default App;
